<template>
  <div>
    <div class="wrap" v-if='isShowHead' >
      <div class="head">
        <div class="head-left">
          <div class="head-info">
            <img class="head-logo" src="../assets/1.png" height="45" width="45" alt="" />
            <p>约约</p>
            <span>&nbsp;-&nbsp;兴趣交友</span>
          </div>
          <p class="head-desc">同城陌生人约电影、约游戏、约锻炼</p>
        </div>
        <div class="head-right">
          <div class="head-router">
            <router-link tag='div' @click.native='selete(index)' :class="{'link-active': nowIndex == index}" v-for='(item,index) in routerList' :to="{path: item.path}" :key='index'>{{item.label}}</router-link>
            <div @click='selete(3)'>加入我们</div>
            <div @click='gotoChat'>聊天</div>
          </div>
          <div class="login1" @click='loginAndRegist'>{{loginStatus}}</div>
        </div>
      </div>
    </div>
    <ResetDialog :is-show='isShow1' @on-close='closeResetDialog' :class="{'tops': isShow1}">
      <Resets></Resets>
    </ResetDialog>
    <Dialog :class="{'tops': isShow1}" :is-show='isShow' @on-close='closeDialog'>
      <Login></Login>
    </Dialog>
    <Dialog :class="{'tops': isShow1}" :is-show='isShow2' @on-close='closeChangeDialog'>
      <ChangePass></ChangePass>
    </Dialog>
  </div>
</template>
<script scoped>
  import Login from './login.vue'
  import Dialog from '../base/dialog.vue'
  import ResetDialog from '../base/resetDialog.vue'
  import Resets from './reset.vue'
  import ChangePass from '../components/user/changePass.vue'
  import { eventBus } from '../eventBus.js'
  export default {
    props: {
      isShowHead: {
        default: true,
        type: Boolean
      }
    },
    components: {
      Dialog,
      Login,
      ResetDialog,
      Resets,
      ChangePass
    },
    data() {
      return {
        nowIndex: 0,
        isShow: false,
        isShow1: false,
        isShow2: false,
        loginStatus: '登录/注册',
        routerList: [
          {
            path: '/index',
            label: "产品"
          },
          {
            path: '',
            label: "用户中心"
          },
          {
            path: '/ours',
            label: '关于我们'
          }
        ],
        dialogVisible: '',
      }
    },
    created() {
      if(localStorage.getItem('headIndex')) {
        this.nowIndex = localStorage.getItem('headIndex')
      }else {
        this.nowIndex = 0
      }
    },
    computed: {
      isLoadTop() {
        if(this.isShow || this.isShow1) {
          return true
        }else {
          return false
        }
      },
    },
    watch: {
      isLoadTop() {
        if(this.isLoadTop) {
          eventBus.$emit('load-top')
        }else {
          eventBus.$emit('load-bottom')
        }
      }
    },
    methods: {
      selete(index) {
        if(index == 3) {
          this.nowIndex = 0
          this.$router.push('/index')
          eventBus.$emit('scroll-top')
        }else {
          if(index == 1) {
            if(localStorage.getItem('loginInfo')) {
              this.nowIndex = index
              this.$router.push('/user')
              localStorage.setItem('headIndex',index)
            }else {
              this.$alert('登录后，才可以查看自己的用户信息，快去吧~！', '温馨提示', {
                confirmButtonText: '确定',
                callback: action => {
                  eventBus.$emit('goto-chat')
                }
              });
            }
          }else {
            this.nowIndex = index
            localStorage.setItem('headIndex',index)
          }
        }
      },
      loginAndRegist() {
        if(localStorage.getItem('loginInfo')) {
          this.nowIndex = 0
          localStorage.setItem('headIndex',0)
          this.loginStatus = '登录/注册'
          localStorage.removeItem('loginInfo')
          this.$router.push('/index')
        }else {
          this.isShow = true
        }
      },
      closeDialog() {
        this.isShow = false
      },
      closeResetDialog() {
        this.isShow1 = false
      },
      closeChangeDialog() {
        this.isShow2 = false
      },
      gotoChat() {
        if(localStorage.getItem('loginInfo')){
          this.$router.push('/chat')
          eventBus.$emit('hide-head')
        }else {
          this.$alert('登录后，可以使用快捷的网页端即时通讯哦，快去吧小伙伴~！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              eventBus.$emit('goto-chat')
            }
          });
        }
      }
    },
    mounted() {
      eventBus.$on('close-dialog',(data) => {
        this.loginStatus = data + '/退出'
        this.isShow = false
      })
      eventBus.$on('forget-passwd',() => {
        this.isShow = false
        this.isShow1 = true
      })
      eventBus.$on('goto-login',() => {
        this.isShow = true
        this.isShow1 = false
      })
      eventBus.$on('goto-chat',() => {
        this.isShow = true
      })
      eventBus.$on('account-changepwd',() => {
        this.isShow2 = true
      })
      eventBus.$on('close-change-pass',() => {
        this.isShow2 = false
      })
      eventBus.$on('change-index',() => {
        this.nowIndex = 0
      })
      if(localStorage.getItem('loginInfo')) {
        this.loginStatus = JSON.parse(localStorage.getItem('loginInfo')).uname + '/退出'
      }
    }
  }
</script>
<style scoped>
  *{
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
  .wrap {
    position: fixed;
    top: 0;
    width: 100%;
    height: 84px;
    min-width: 1200px;
    border-bottom: 1px solid #fff;
    background: #fff;
    z-index: 1003;
    box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.25);
  }
  .head {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    height: 84px;
    margin: 0 auto;
  }
  .head-left {
    height: 64px;
    padding-top: 20px;
  }
  .head-info {
    display: flex;
    align-items: center;
    height: 45px;
  }
  .head-logo {
    display: block;
    width: 45px;
    height: 45px;
    margin: 0 14px 0 9px;
  }
  .head-info p {
    height: 24px;
    font-size: 24px;
    line-height: 24px;
    color: #105a75;
  }
  .head-info span {
    display: block;
    height: 24px;
    font-size: 18px;
    line-height: 24px;
    color: #105a75;
  }
  .head-desc {
    height: 19px;
    font-size: 16px;
    line-height: 19px;
    margin-left: 9px;
    color: #999;
  }
  .head-right {
    display: flex;
    align-items: center;
  }
  .head-router {
    display: flex;
    height: 42px;
    padding-top: 42px;
  }
  .head-router div {
    height: 18px;
    padding: 0 24px 20px;
    cursor: pointer;
    margin-left: 40px;
    text-decoration: none;
    font-size: 18px;
    line-height: 18px;
    text-align: center;
    color: #105a75;
    border-bottom: 4px solid #fff;
    /*border-bottom: 4px solid rgba(16, 90, 117, 1);*/
  }
  .head-router .link-active {
    border-bottom-color: #105a75;
  }
  .login1 {
    height: 32px;
    cursor: pointer;
    margin-left: 40px;
    font-size: 14px;
    line-height: 32px;
    color: #105a75;
    padding: 0 15px 0 40px;
    border: 1px solid #105a75;
    background: url(../assets/2.png) 12px center no-repeat;
    background-size: 20px 20px;
    border-radius: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/components/header.vue